import { createSlice } from "@reduxjs/toolkit";
import { getCouponsDetailsAPI } from "../../api/coupons";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCouponsDetailsSlice = createSlice({
  name: "getCouponsDetails",
  initialState: data,
  reducers: {
   getCouponsDetailsSlice(state) {
      state.isLoading = true;
    },
   getCouponsDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCouponsDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getCouponsDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCouponsDetailsHandler: any = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getCouponsDetailsAction.getCouponsDetailsSlice());
    const response: any = await getCouponsDetailsAPI(id);
    
    dispatch(getCouponsDetailsAction.getCouponsDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCouponsDetailsAction.getCouponsDetailsSliceFailure(e?.response?.data));
  }
};
export default getCouponsDetailsSlice.reducer;
export const getCouponsDetailsAction = getCouponsDetailsSlice.actions;
